// src/i18n.js
import { createI18n } from "vue-i18n"

function detectLocale() {
	const lang = navigator.language || 'fr'
	const code = lang.toLowerCase().split('-')[0]
	const supported = ['fr', 'en']
	return supported.includes(code) ? code : 'fr'
}

// Définis tes traductions
const messages = {
	en: {
		pikaPlayer: {
			title: "Pika training module",
			retry: "Try again",
			invalid_link: "Invalid Pika module link.",
			timeout: "The module is not responding. Check your connection and try again.",
			media_error: "A module resource could not be loaded.",
			save_error: "Your progress could not be saved. Check your connection.",
			retry_save: "Retry saving",
		},

		auth: {
			hello: "Welcome { firstName },",
			invitation_message: "Your company <strong>{ companyName }</strong> invites you to take the training course <strong>{ formationName }</strong>.<br/><br/>This training has been designed to provide you with essential knowledge and strengthen your professional skills.",
			submit: "Start your training",
			auth_link_error: "Unable to log you in with this link, please contact contact@pika-aero.com."
		},
		bravo: {
			title_success: "Congratulations { firstName },",
			title_failure: "Unfortunately { firstName },",
			success_message: "You have just completed the training course <strong>{ formationName }</strong> with a final score of <strong>{ finalScore }%</strong>.<br/><br/>Your certificate has been sent to your manager.",
			failure_message: "After analyzing your results, we regret to inform you<br/>that you have not passed the training course <strong>{ formationName }</strong> with a score of <strong>{ finalScore }%</strong>.<br/><br/>",
			failure_message_eliminatory: "After analyzing your results, we regret to inform you that you did not pass an eliminatory question.<br/><br/>The training course <strong>{ formationName }</strong> is therefore <strong>not validated</strong>.<br/><br/>",
			retry_cta: "Retry the final evaluation",
			load_error: "An error occurred, please contact contact@pika-aero.com.",
			retry_error: "Unable to restart the training, please contact contact@pika-aero.com",
			feedback_prompt: "Help us improve our trainings by sharing your experience in less than 2 minutes.",
			feedback_cta: "Give my feedback"
		},
		expired: {
			title: "Your training has expired { firstName },",
			content: "Your training { formationName } has unfortunately expired.",
			legal: "In accordance with the decree of June 5, 2025 (amending that of September 11, 2013 relating to civil aviation security measures),<br/>security training must be completed within a maximum period of 30 days.<br />",
			contact_manager: "We invite you to contact your manager in order to request a new one.",
			load_error: "An error occurred, please contact contact@pika-aero.com.",
		},
		cancelled: {
			title: "Your training has been cancelled { firstName },",
			title_generic: "Your training has been cancelled,",
			contact_manager: "We invite you to contact your manager..",
			load_error: "An error occurred, please contact contact@pika-aero.com.",
		},
		quiz: {
			final: {
				title: "Final evaluation",
				description: "You will now access the final evaluation which marks the completion of your training.<br/>It includes { finalQuestionsCount } questions.<br/><br/>To pass the training, you must obtain at least { validationRate }% correct answers,<br/>which means a minimum of { minCorrectAnswers } correct answers out of { finalQuestionsCount }.",
				attempts_note: "You have a maximum of <strong>{ attempts } attempts</strong> to pass this final evaluation.",
				start_cta: "Start the final evaluation"
			},
			evaluation_code: {
				title: "Validation code for your final evaluation",
				description: "Before accessing your final evaluation, please confirm your identity by entering<br/>the evaluation code provided by your manager.",
				submit_cta: "Verify the code",

				empty_code: "Please enter a valid verification code.",
				invalid_code: "This verification code is invalid, please contact your manager",
			},

			title: "Test your knowledge",
			loading: "Loading...",
			submit_reply_cta: "Submit your answer",
			next_question_cta: "Next question",
			no_select_error: "Please select at least one answer!",
			select_n_answers: "Select { n } answers",
			eliminatory_tag: "Eliminatory",
			time_expired: "Your evaluation time has expired. Please submit your answers as soon as possible.",

			load_error: "An error occurred, please contact contact@pika-aero.com.",
			submit_error: "An error occurred, please contact contact@pika-aero.com.",
		},
		learning: {
			previous_cta: "Previous",
			next_cta: "Next",
			back_summary_cta: "Back to summary",
			load_error: "An error occurred, please contact contact@pika-aero.com.",
		},
		no_mobile: {
			title: "Mobile access denied,",
			description: "Your employer has disabled access to this training from mobile devices.<br/>Please log in from a computer to continue your training.",
		},
		replay: {
			previous_cta: "Previous",
			next_cta: "Next",
			finish_cta: "Finish",
			back_summary_cta: "Back to summary",
			load_error: "An error occurred, please contact contact@pika-aero.com.",
		},
		summary: {
			title: "Training",
			module: "Module",

			chapters_count: "{count} chapter | {count} chapters",
			chapters_finished_count: "{count} completed | {count} completed",

			replay_cta: "View again",
			continue_cta: "Continue",

			final_quiz_title: "Final assessment",
			final_quiz_subtitle: "Final evaluation",
			final_quiz_description: "Complete all modules to unlock the final evaluation",

			load_error: "An error occurred, please contact contact@pika-aero.com.",

			status: {
				completed: "Completed",
				in_progress: "In progress",
				locked: "Locked",
				available: "Available"
			}
		},
		login: {
			hello: "Hello,",
			note: "Please enter your trainee code to authenticate",
			input_placeholder: "Enter your trainee code",
			submit: "Start",
			login_link_error: "This login code is invalid, please contact contact@pika-aero.com"
		},
		micro_learning: {
			loading: "Loading...",
			welcome: {
				hello: "Welcome,",
				hello_name: "Welcome, {firstName}",
				assigned_by: "{companyName} assigned you the module",
				questions_count: "{count} questions",
				duration: "2 min",
				warning: "You only have one attempt to complete this quiz.",
				start_cta: "Start Quiz",
				skip: "Skip"
			},
			quiz: {
				question_of: "Question {current} / {total}",
				submit_cta: "Submit",
				next_cta: "Continue",
				see_results_cta: "See Results",
				hint_multiple: "Multiple answers possible",
				feedback_correct: "Correct!",
				feedback_incorrect: "Incorrect"
			},
			results: {
				eyebrow: "Quiz Complete",
				title: "Thanks, {firstName}!",
				subtitle_perfect: "Perfect score!",
				subtitle_good: "Great job!",
				subtitle_ok: "Keep learning!",
				correct_answers: "{count}/{total}",
				score_label: "SCORE",
				recap_title: "Your Answers",
				your_answer: "Your answer",
				correct_answer: "Correct answer",
				close_cta: "Close",
				scoring_perfect: "Competency confirmed — excellent knowledge demonstrated.",
				scoring_good: "Competency broadly confirmed, with one point to refresh.",
				scoring_low: "Refresher training recommended before independent task performance."
			},
			errors: {
				invalid_token: "This link is invalid or has expired.",
				already_completed: "This quiz has already been completed.",
				session_expired: "Your session has expired. Please reload the page.",
				generic: "An error occurred. Please try again."
			}
		},
		virtual_classroom: {
			loading: "Loading...",
			home: {
				eyebrow: "Virtual classroom",
				hello_name: "Hello, {firstName}",
				meeting_title: "Video meeting",
				instructor: "Instructor",
				day_label: "Day",
				evaluation_label: "Evaluation",
				schedule_title: "Schedule",
				day: "day",
				days: "days",
				today: "Today",
				join_meeting: "Join on {provider}",
				join_meeting_other: "Join the meeting",
				chapters_title: "Evaluations",
				question_count: "{count} question(s)",
				status_locked: "Locked",
				status_available: "Start",
				status_available_label: "Available",
				status_in_progress: "Continue",
				status_in_progress_label: "In progress",
				status_completed: "Completed",
				view_results: "View my answers",
				locked_hint: "Your instructor will unlock the evaluations during the session."
			},
			quiz: {
				submit_cta: "Submit",
				next_cta: "Continue",
				see_results_cta: "See results",
				hint_multiple: "Multiple answers possible",
				feedback_correct: "Correct answer!",
				feedback_incorrect: "Incorrect answer"
			},
			results: {
				eyebrow: "Evaluation complete",
				title: "Well done, {firstName}!",
				score_label: "SCORE",
				recap_title: "Your answers",
				your_answer: "Your answer",
				correct_answer: "Correct answer",
				back_cta: "Back to evaluations"
			},
			errors: {
				invalid_token: "This link is invalid or has expired.",
				locked: "This chapter is locked.",
				generic: "An error occurred. Please try again."
			}
		},
		feedback: {
			title: "Your feedback",
			intro: "Thank you for taking a few minutes to share your experience. Your answers help us improve our trainings.",
			loading: "Loading...",
			submit: "Submit",
			submitting: "Submitting...",
			thanks_title: "Thank you!",
			thanks_message: "Your feedback has been recorded.",
			already_submitted: "Your feedback has already been recorded.",
			load_error: "Unable to load the feedback form, please contact contact@pika-aero.com.",
			submit_error: "Unable to submit your feedback, please try again.",
			yes: "Yes",
			no: "No",
			text_placeholder: "Your answer...",
			improvements_required_prompt: "What could we have improved?",
			step: "Question {current} of {total}",
			previous: "Previous",
			next: "Next",
			intro_title: "We'd love your feedback",
			intro_body: "We'll ask you <strong>a few quick questions</strong> about your experience with this training.",
			intro_why: "Your feedback drives our continuous improvement, every answer helps us build better trainings for you and your colleagues.",
			intro_cta: "Let's start",
			intro_duration: "Takes less than 2 minutes"
		},
	},
	fr: {
		pikaPlayer: {
			title: "Module de formation Pika",
			retry: "Réessayer",
			invalid_link: "Lien du module Pika invalide.",
			timeout: "Le module ne répond pas. Vérifiez votre connexion puis réessayez.",
			media_error: "Un média du module n’a pas pu être chargé.",
			save_error: "La progression n’a pas pu être enregistrée. Vérifiez votre connexion.",
			retry_save: "Réessayer l’enregistrement",
		},

		auth: {
			hello: "Bienvenue { firstName },",
			invitation_message: "Votre entreprise <strong>{ companyName }</strong> vous invite à suivre la formation <strong>{ formationName }</strong>.<br/><br/>Cette formation a été conçue pour vous offrir des connaissances essentielles et renforcer vos compétences professionnelles.",
			submit: "Commencer",
			auth_link_error: "Impossible de vous connecter avec ce lien, merci de contacter contact@pika-aero.com."
		},
		bravo: {
			title_success: "Bravo { firstName },",
			title_failure: "Mince { firstName },",
			success_message: "Vous venez de terminer la formation <strong>{ formationName }</strong> avec un score de <strong>{ finalScore }%</strong>.<br/><br/>Votre attestation a été envoyée à votre responsable.",
			failure_message: "Après analyse de vos résultats, nous sommes au regret de vous informer<br/>que vous n'avez pas validé la formation <strong>{ formationName }</strong> avec un score de <strong>{ finalScore }%</strong>.<br/><br/>",
			failure_message_eliminatory: "Après analyse de vos résultats, nous sommes au regret de vous informer que vous avez échoué à une question éliminatoire.<br/><br/>La formation <strong>{ formationName }</strong> n'est donc <strong>pas validée</strong>.<br/><br/>",
			retry_cta: "Recommencer le quiz final",
			load_error: "Une erreur est survenue, merci de contacter contact@pika-aero.com.",
			retry_error: "Impossible de recommencer la formation, merci de contacter contact@pika-aero.com",
			feedback_prompt: "Aidez-nous à améliorer nos formations en partageant votre expérience en moins de 2 minutes.",
			feedback_cta: "Donner mon avis"
		},
		expired: {
			title: "Votre formation à expiré { firstName },",
			content: "Votre formation « { formationName } » a malheureusement expiré.",
			legal: "Conformément à l’arrêté du 5 juin 2025 (modifiant celui du 11 septembre 2013 relatif aux mesures de sûreté de l’aviation civile),<br/>les formations sûreté doivent être réalisées dans un délai maximum de 30 jours.<br />",
			contact_manager: "Nous vous invitons à contacter votre responsable afin de pouvoir en recommander une nouvelle.",
			load_error: "Une erreur est survenue, merci de contacter contact@pika-aero.com.",
		},
		cancelled: {
			title: "Votre formation a été annulée { firstName },",
			title_generic: "Votre formation a été annulée,",
			contact_manager: "Nous vous invitons à contacter votre responsable.",
			load_error: "Une erreur est survenue, merci de contacter contact@pika-aero.com.",
		},
		quiz: {
			final: {
				title: "Le Test Final",
				description: "Vous allez maintenant accéder au test final qui marque l’aboutissement de votre formation.<br/>Il comprend { finalQuestionsCount } questions.<br/><br/>Pour valider la formation, vous devez obtenir au moins { validationRate } % de bonnes réponses,<br/>soit un minimum de { minCorrectAnswers } bonnes réponses sur { finalQuestionsCount }.",
				attempts_note: "Vous disposez de <strong>{ attempts } tentatives</strong> au maximum pour valider ce test final.",
				start_cta: "Commencer le test final"
			},
			evaluation_code: {
				title: "Code de validation pour votre test final",
				description: "Avant d’accéder à votre test final, veuillez confirmer votre identité en saisissant<br/>le code d'évaluation communiqué par votre responsable.",
				submit_cta: "Vérifier le code",

				empty_code: "Merci de saisir un code de vérification valide.",
				invalid_code: "Ce code de vérification est invalide, merci de contacter votre responsable",
			},

			title: "Testez vos connaissances",
			loading: "Chargement...",
			submit_reply_cta: "Valider votre réponse",
			next_question_cta: "Question suivante",
			no_select_error: "Veuillez sélectionner au moins une réponse !",
			select_n_answers: "Sélectionnez { n } réponses",
			eliminatory_tag: "Éliminatoire",
			time_expired: "Le temps imparti pour l’évaluation est écoulé. Merci de soumettre vos réponses dès que possible.",

			load_error: "Une erreur est survenue, merci de contacter contact@pika-aero.com.",
			submit_error: "Une erreur est survenue, merci de contacter contact@pika-aero.com.",
		},
		initial_evaluation: {
			"adaptive": {
				"title": "Quiz d'Évaluation Adaptatif",
				"description": "Répondez à quelques questions pour que nous puissions adapter votre formation à votre niveau et vos besoins. Ce quiz nous permettra de personnaliser votre parcours d'apprentissage.",
				"feature_1": "Adapté à votre niveau",
				"feature_2": "Formation personnalisée",
				"feature_3": "Progression optimisée",
				"start_cta": "Commencer le quiz"
			},
			"loading": {
				"message": "Chargement des questions..."
			},
			"analyzing": {
				"message_1": "Analyse de vos réponses en cours...",
				"message_2": "Évaluation de votre niveau...",
				"message_3": "Personnalisation de votre parcours...",
				"message_4": "Finalisation de votre formation adaptée..."
			},
			"completion": {
				"title": "Évaluation Terminée !",
				"description": "Félicitations ! Vous avez complété l'évaluation initiale. Nous avons analysé vos réponses pour personnaliser votre parcours de formation.",
				"score": "Score",
				"level": "Niveau",
				"level_beginner": "Débutant",
				"level_intermediate": "Intermédiaire",
				"level_advanced": "Avancé",
				"start_learning": "Commencer ma formation"
			},
			"load_error": "Erreur lors du chargement du quiz. Veuillez réessayer.",
			"submit_error": "Erreur lors de l'enregistrement de votre réponse."
		},
		learning: {
			previous_cta: "Précédent",
			next_cta: "Suivant",
			back_summary_cta: "Retour au sommaire",
			load_error: "Une erreur est survenue, merci de contacter contact@pika-aero.com.",
		},
		no_mobile: {
			title: "Accès mobile interdit,",
			description: "Votre employeur a désactivé l’accès à cette formation depuis les appareils mobiles.<br/>Merci de vous connecter depuis un ordinateur pour poursuivre votre formation.",
		},
		replay: {
			previous_cta: "Précédent",
			next_cta: "Suivant",
			finish_cta: "Terminer",
			back_summary_cta: "Retour au sommaire",
			load_error: "Une erreur est survenue, merci de contacter contact@pika-aero.com.",
		},
		summary: {
			title: "Formation",
			module: "Module",

			chapters_count: "{count} chapitre | {count} chapitres",
			chapters_finished_count: "{count} terminé | {count} terminés",

			replay_cta: "Revoir",
			continue_cta: "Continuer",

			final_quiz_title: "Évaluation finale",
			final_quiz_subtitle: "Évaluation finale",
			final_quiz_description: "Complétez tous les modules pour débloquer l'evaluation finale",

			load_error: "Une erreur est survenue, merci de contacter contact@pika-aero.com.",

			status: {
				completed: "Terminé",
				in_progress: "En cours",
				locked: "Verrouillé",
				available: "Disponible"
			}
		},
		login: {
			hello: "Bonjour,",
			note: "Merci de rentrer votre code stagiaire afin de vous authentifier",
			input_placeholder: "Entrez votre code stagiaire",
			submit: "Commencer",
			login_link_error: " Ce code de connexion est invalide, merci de contacter contact@pika-aero.com"
		},
		micro_learning: {
			loading: "Chargement...",
			welcome: {
				hello: "Bienvenue,",
				hello_name: "Bienvenue, {firstName}",
				assigned_by: "{companyName} vous a assigné le module",
				questions_count: "{count} questions",
				duration: "2 min",
				warning: "Vous n'avez qu'une seule tentative pour compléter ce quiz.",
				start_cta: "Commencer le quiz",
				skip: "Passer"
			},
			quiz: {
				question_of: "Question {current} / {total}",
				submit_cta: "Valider",
				next_cta: "Continuer",
				see_results_cta: "Voir les résultats",
				hint_multiple: "Plusieurs réponses possibles",
				feedback_correct: "Bonne réponse !",
				feedback_incorrect: "Mauvaise réponse"
			},
			results: {
				eyebrow: "Quiz terminé",
				title: "Merci, {firstName} !",
				subtitle_perfect: "Score parfait !",
				subtitle_good: "Bien joué !",
				subtitle_ok: "Continuez à apprendre !",
				correct_answers: "{count}/{total}",
				score_label: "SCORE",
				recap_title: "Vos réponses",
				your_answer: "Votre réponse",
				correct_answer: "Bonne réponse",
				close_cta: "Fermer",
				scoring_perfect: "Compétence confirmée — excellentes connaissances démontrées.",
				scoring_good: "Compétence globalement confirmée, avec un point à rafraîchir.",
				scoring_low: "Formation de remise à niveau recommandée avant toute activité autonome."
			},
			errors: {
				invalid_token: "Ce lien est invalide ou a expiré.",
				already_completed: "Ce quiz a déjà été complété.",
				session_expired: "Votre session a expiré. Veuillez recharger la page.",
				generic: "Une erreur est survenue. Veuillez réessayer."
			}
		},
		virtual_classroom: {
			loading: "Chargement...",
			home: {
				eyebrow: "Classe virtuelle",
				hello_name: "Bonjour, {firstName}",
				meeting_title: "Visioconférence",
				instructor: "Instructeur",
				day_label: "Jour",
				evaluation_label: "Évaluation",
				schedule_title: "Planning",
				day: "jour",
				days: "jours",
				today: "Aujourd'hui",
				join_meeting: "Rejoindre sur {provider}",
				join_meeting_other: "Rejoindre la réunion",
				chapters_title: "Évaluations",
				question_count: "{count} question(s)",
				status_locked: "Verrouillé",
				status_available: "Commencer",
				status_available_label: "Disponible",
				status_in_progress: "Continuer",
				status_in_progress_label: "En cours",
				status_completed: "Terminé",
				view_results: "Voir mes réponses",
				locked_hint: "Votre formateur débloquera les évaluations au fil de la session."
			},
			quiz: {
				submit_cta: "Valider",
				next_cta: "Continuer",
				see_results_cta: "Voir les résultats",
				hint_multiple: "Plusieurs réponses possibles",
				feedback_correct: "Bonne réponse !",
				feedback_incorrect: "Mauvaise réponse"
			},
			results: {
				eyebrow: "Évaluation terminée",
				title: "Bravo, {firstName} !",
				score_label: "SCORE",
				recap_title: "Vos réponses",
				your_answer: "Votre réponse",
				correct_answer: "Bonne réponse",
				back_cta: "Retour aux évaluations"
			},
			errors: {
				invalid_token: "Ce lien est invalide ou a expiré.",
				locked: "Ce chapitre est verrouillé.",
				generic: "Une erreur est survenue. Veuillez réessayer."
			}
		},
		feedback: {
			title: "Votre avis",
			intro: "Merci de prendre quelques minutes pour partager votre expérience. Vos réponses nous aident à améliorer nos formations.",
			loading: "Chargement...",
			submit: "Envoyer",
			submitting: "Envoi en cours...",
			thanks_title: "Merci !",
			thanks_message: "Votre avis a bien été enregistré.",
			already_submitted: "Votre avis a déjà été enregistré.",
			load_error: "Impossible de charger le formulaire, merci de contacter contact@pika-aero.com.",
			submit_error: "Impossible d'envoyer votre avis, merci de réessayer.",
			yes: "Oui",
			no: "Non",
			text_placeholder: "Votre réponse...",
			improvements_required_prompt: "Qu'aurait-on pu améliorer ?",
			step: "Question {current} sur {total}",
			previous: "Précédent",
			next: "Suivant",
			intro_title: "Votre avis compte pour nous",
			intro_body: "Nous allons vous poser <strong>quelques questions rapides</strong> sur votre expérience avec cette formation.",
			intro_why: "Votre retour alimente notre démarche d'amélioration continue, chaque réponse nous aide à construire de meilleures formations pour vous et vos collègues.",
			intro_cta: "C'est parti",
			intro_duration: "Moins de 2 minutes"
		},
	}
}

// Initialise i18n
const i18n = createI18n({
	legacy: false,
	locale: detectLocale(),
	fallbackLocale: 'fr',
	messages
})

export default i18n
